const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const CanvasUtil = require("../util/CanvasUtil");
const CanvasImage = require("../util/CanvasImage");
const ColorUtil = require("../util/ColorUtil");
const ContainerSize = require("../util/ContainerSize");
const withContainerDims = require("../hoc/withContainerDims");
const ErrorUtil = require("../../../shared/ErrorUtil");

// This view works by creating or receiving a Canvas element using the DOM API
// and manually adding it and removing it to a React-controlled container.

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withContainerDims(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "CanvasView",

		propTypes: {
			// Props should provide at least one of
			// - canvasEl: pass an existing canvas element to use
			// - width and height: explicitly set width and height
			// If you would like CSS to measure the Canvas size for you, use the
			// MeasuredEl component. (This used to be the autosize prop.)
			canvasEl: PT.instanceOf(global.HTMLCanvasElement),
			width: PT.number,
			height: PT.number,
			padding: PT.object,
			className: PT.string,
			// draw takes two arguments: the context, and options {resized, loadedImages}.
			draw: PT.func.isRequired,
			canvasType: PT.string,
			noContextMenu: PT.bool,
			noPointerEvents: PT.bool,
			isMeasured: PT.bool,
			// Set to true if you don't want to free the canvas memory on unmount.
			preserveCanvasEl: PT.bool,

			// Injected by HOCs
			containerDims: PT.shape({
				width: PT.number.isRequired,
				height: PT.number.isRequired,
				left: PT.number.isRequired,
				top: PT.number.isRequired,
				windowWidth: PT.number.isRequired,
				windowHeight: PT.number.isRequired,
			}).isRequired,
		},

		getInitialState: function() {
			return this.makeInternalCanvas();
		},

		UNSAFE_componentWillReceiveProps: function(nextProps) {
			this.setState(this.makeInternalCanvas(nextProps));
		},

		componentDidMount: function() {
			this.containerDiv.appendChild(this.state.canvasEl);
			this.redrawCanvas();

			// If the window is moved to a monitor with a different canvas DPR, we may
			// need to update the component.
			CanvasUtil.addDPRListener(this.onDPRChange);
		},

		UNSAFE_componentWillUpdate: function(nextProps, nextState) {
			if (this.containerDiv && this.state.canvasEl !== nextState.canvasEl) {
				this.containerDiv.removeChild(this.state.canvasEl);
				this._needsReadd = true;
			}
		},

		componentDidUpdate: function() {
			if (this.containerDiv && this._needsReadd) {
				this.containerDiv.appendChild(this.state.canvasEl);
				this._needsReadd = false;
			}
			this.redrawCanvas();
		},

		componentWillUnmount: function() {
			if (this.state.canvasEl && !this.props.preserveCanvasEl) {
				CanvasUtil.freeCanvasMemory(this.state.canvasEl, {
					source: "Canvas",
				});
			}
			CanvasUtil.removeDPRListener(this.onDPRChange);
			this.unmounted = true;
		},

		redrawCanvas: function() {
			if (this.state.canvasW > 0 && this.state.canvasH > 0) {
				try {
					CanvasImage.withLoading(
						this.getContext(),
						context => {
							// The draw method may be interested in knowing if the Canvas was just
							// resized (necessitating a full redraw) or if any drawn images just
							// finishes loading. Provide this information in the second argument.
							this.props.draw(context, {
								resized: !!this.wasResized,
								loadedImages: !!this.justLoadedImages,
							});
							this.wasResized = false;
							this.justLoadedImages = false;
						},
						() => {
							// If images finish loading, we need to redraw the canvas. This will
							// error if we've unmounted, so check for that first.
							if (!this.unmounted) {
								this.justLoadedImages = true;
								this.forceUpdate();
							}
						}
					);
				} catch (err) {
					ErrorUtil.log(
						"E_UNSPECIFIED_CANVAS_ERROR",
						"Encountered an error redrawing canvas.",
						err
					);
				}
			}
		},

		onDPRChange: function() {
			this.setState(this.makeInternalCanvas(this.props, {dprChanged: true}));
		},

		// Returns an object with canvasEl, canvasW, canvasH keys, which are the keys
		// of this component's state, i.e. the return of this method can be passed to
		// setState. If the canvas element has not been created, it creates one. If
		// props are not passed in it uses the component's current props.
		makeInternalCanvas: function(props, options) {
			props = props || this.props;
			options = options || {};
			const origState = this.state || {};
			let el;
			let w;
			let h;

			if (props.canvasEl) {
				el = props.canvasEl;
				w = props.width || el.width;
				h = props.height || el.height;
			} else {
				el = origState.canvasEl;
				w = props.width;
				h = props.height;
			}
			if (
				origState.canvasEl &&
				origState.canvasEl !== el &&
				!this.props.preserveCanvasEl
			) {
				CanvasUtil.freeCanvasMemory(origState.canvasEl, {
					source: "Canvas",
				});
			}

			// Setting the Canvas width and height resets the context and forces a
			// redraw. We make sure to only do this when we have to, and we set
			// this.wasResized to true to indicate that a full redraw is necessary.
			if (!el) {
				el = CanvasUtil.createCanvas(w, h, {
					source: "Canvas",
				});
				CanvasUtil.setCanvasDPI(el);
				this.wasResized = true;
			} else if (
				options.dprChanged ||
				w !== origState.canvasW ||
				h !== origState.canvasH ||
				el !== origState.canvasEl
			) {
				el.width = w;
				el.height = h;
				CanvasUtil.setCanvasDPI(el);
				this.wasResized = true;
			}

			if (this.props.isMeasured) {
				el.style.width = "100%";
				el.style.height = "100%";
			}

			// We use the onblah way of attaching events so that we're able to
			// ensure we don't attach it more than once.
			if (props.noContextMenu && !el.oncontextmenu) {
				el.oncontextmenu = e => e.preventDefault();
			}

			// Set some default context values.
			const context = CanvasUtil.getShortvas(el);
			context.font = this.getFontSize() + "px Roboto";
			ColorUtil.setDefaultScheme(context);

			return {
				canvasEl: el,
				canvasW: w,
				canvasH: h,
			};
		},

		render: function() {
			let style = {
				position: "relative",
			};
			if (this.props.isMeasured) {
				style.width = "100%";
				style.height = "100%";
			}
			if (this.props.padding) {
				const p = this.props.padding;
				style = {
					paddingLeft: p.left,
					paddingRight: p.right,
					paddingTop: p.top,
					paddingBottom: p.bottom,
				};
			}
			if (this.props.noPointerEvents) {
				style.pointerEvents = "none";
			}
			// The <canvas> is created in the makeInternalCanvas method, and inserted into this div in componentDidMount.
			return (
				<div
					className={this.props.className || ""}
					style={style}
					ref={ref => (this.containerDiv = ref)}
				/>
			);
		},

		// Methods for external use.

		getCanvasEl: function() {
			return this.state.canvasEl;
		},

		getContext: function() {
			return CanvasUtil.getShortvas(this.state.canvasEl);
		},

		getCanvasSize: function() {
			return {w: this.state.canvasW, h: this.state.canvasH};
		},

		getFontSize: function() {
			const fontSizeTable = ContainerSize.getFontSizes(
				this.props.containerDims
			);
			return fontSizeTable[this.props.canvasType || "canvas"];
		},
	})
);
